import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from 'rxjs';
import { GlobalDataService } from 'src/app/shared/services/angular-service/global-data.service';
import { LocalStorageService } from "src/app/shared/services/angular-service/local-storage.service";

@Component({
  selector: 'app-profile-nav-page',
  templateUrl: './profile-nav-page.component.html',
  styleUrl: './profile-nav-page.component.scss',
})
export class ProfileNavPageComponent implements OnInit {

  deviceType;
  urlPosition='';

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private globalDataService: GlobalDataService
  ) {

    this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      if(this.router.url !== '/account'){
        this.urlPosition = this.router.url;
        this.globalDataService.setGlobalValue('profile_last_url', this.urlPosition);
      }
      this.urlPosition = this.globalDataService.getGlobalValue('profile_last_url');
    });

    this.deviceType = localStorageService.getItem('deviceType');
    if (this.deviceType !== 'mobile') {
      this.router.navigate(['account/profile'], { replaceUrl: true });
    }
  }

  ngOnInit() {

  }
}
